/** Live production onboarding — mock must never be enabled on this host. */
export const PRODUCTION_ONBOARDING_HOSTNAME =
  "pfs-onboarding.passportcard.co.il";

export function isProductionPassportcardOnboardingHost(): boolean {
  if (typeof window === "undefined") {
    return false;
  }
  return (
    window.location.hostname.toLowerCase() === PRODUCTION_ONBOARDING_HOSTNAME
  );
}

/** Hosts where /testing and mock toggles are allowed — keep in sync with DevStagingRoute. */
export function isDevStagingOrLocalhostHost(): boolean {
  if (typeof window === "undefined") {
    return false;
  }
  const currentUrl = window.location.href.toLowerCase();
  return (
    currentUrl.includes("dev") ||
    currentUrl.includes("staging") ||
    currentUrl.includes("localhost")
  );
}
